<template>
  <Modal v-model="state" title="快速联调" width="443" class-name="c-modal vertical-center-modal" :mask-closable="false" :closable="false">
    <div class="c-form">
      <Form :label-width="130">
        <FormItem>
          <CheckboxGroup v-model="callbackSettings">
            <Checkbox label="callbackType_pay" disabled>激活</Checkbox>
            <Checkbox label="callbackType_active" disabled>注册</Checkbox>
            <Checkbox label="callbackType_regist" disabled>付费</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="IMEI/OAID/IDFA">
          <el-input v-model.trim="deviceNo" placeholder="请输入设备号" style="width: 240px" size="small" />
        </FormItem>
        <FormItem>
          <div style="width: 240px; line-height: 20px">
            <span style="color: #ff6400">提示：不输入设备号联调，会联调最后一个点击数据</span>
          </div>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="closeModal">关闭</Button>
        <Button type="primary" :loading="loading" @click="quickDebug">
          <span v-if="loading">联调中...</span>
          <span v-else>联调</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { quickDebugByMedia } from '@/api/track.plan.model'

export default {
  name: 'quickDebug',
  props: {
    value: {
      type: Boolean
    },
    planInfo: {
      type: Object
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    quickDebug() {
      const { planId, platform, mediaId, sourceId } = this.planInfo
      const params = {
        planId,
        platform,
        mediaId,
        sourceId,
        deviceNo: this.deviceNo,
        callbackSettings: JSON.stringify({
          callbackType_pay: Number(this.callbackSettings.includes('callbackType_pay')),
          callbackType_active: Number(this.callbackSettings.includes('callbackType_active')),
          callbackType_regist: Number(this.callbackSettings.includes('callbackType_regist'))
        })
      }
      this.loading = true
      quickDebugByMedia(params).then((data) => {
        this.loading = false
        if (data) {
          const { result, message } = data
          if (result) {
            this.$Message.success('联调成功')
            this.closeModal()
          } else this.$Message.error(message)
        }
      })
    },
    closeModal() {
      this.$emit('input', false)
      this.callbackSettings = ['callbackType_pay', 'callbackType_active', 'callbackType_regist']
    }
  },
  data() {
    return {
      loading: false,
      callbackSettings: ['callbackType_pay', 'callbackType_active', 'callbackType_regist'],
      deviceNo: ''
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.c-form {
  width: 100%;
  flex: auto;
  display: flex;
  justify-content: left;
  margin-bottom: 8px;

  ::v-deep .ivu-form-item {
    margin-bottom: 0;
    text-align: left;
    height: 32px;
  }

  ::v-deep .el-input__inner {
    height: 24px !important;
    line-height: 24px !important;
  }
}
</style>
